/**
 * Chatbot
 *
 * @selector .js-Chatbot
 * @enabled true
 */

import BaseModule from '../../modules/BaseModule.js';
import $ from 'jquery';

export default class Chatbot extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;
        this.$el = $(element);

        const $chatbot = this.$el;
        const $chatbotChat = this.$el.find('.js-ChatbotChat');
        const $chatbotTrigger = this.$el.find('.js-ChatbotTrigger');
        const $chatbotClose = this.$el.find('.js-ChatbotChatClose');

        /**
         * Listen for click on the chatbot button
         */
        $chatbotTrigger.on('click', (e) => {
            e.preventDefault();

            const scriptPathMigros = $chatbot.attr('data-chatbot-script-asset-migros');

            $('#webchat #frame').attr('src', scriptPathMigros);
            $chatbotChat.removeClass('d-none');
            $chatbotTrigger.addClass('d-none');
            $chatbot.addClass('chatbot--open');
            $chatbot.attr('data-chatbot-loaded', true);
        });

        $chatbotClose.on('click', (e) => {
            e.preventDefault();
            $chatbotChat.addClass('d-none');
            $chatbot.removeClass('chatbot--open');
            $chatbotTrigger.removeClass('d-none');
        });
    }
}
